// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3rGG9","productName":"Table_productName__bfKbY"};